var _typeof = require("@babel/runtime/helpers/typeof");
require("core-js/modules/es.regexp.exec.js");
require("core-js/modules/es.string.split.js");
require("core-js/modules/es.array.filter.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.object.keys.js");
require("core-js/modules/es.string.replace.js");
require("core-js/modules/es.regexp.constructor.js");
require("core-js/modules/es.regexp.dot-all.js");
require("core-js/modules/es.regexp.sticky.js");
require("core-js/modules/es.regexp.to-string.js");
require("core-js/modules/es.promise.js");
require("core-js/modules/es.string.search.js");
require("core-js/modules/es.array.index-of.js");
require("core-js/modules/es.json.stringify.js");
require("core-js/modules/es.object.assign.js");
require("core-js/modules/es.array.map.js");
require("core-js/modules/es.array.includes.js");
require("core-js/modules/es.string.includes.js");
require("core-js/modules/es.array.sort.js");
require("core-js/modules/es.array.slice.js");
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.array.splice.js");
require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/web.dom-collections.iterator.js");
require("core-js/modules/web.url.js");
require("core-js/modules/web.url-search-params.js");
/**!
 * FlexSearch.js v0.7.31 (Bundle)
 * Copyright 2018-2022 Nextapps GmbH
 * Author: Thomas Wilkerling
 * Licence: Apache-2.0
 * https://github.com/nextapps-de/flexsearch
 */
(function _f(self) {
  'use strict';

  try {
    if (module) self = module;
  } catch (e) {}
  self._factory = _f;
  var t;
  function u(a) {
    return "undefined" !== typeof a ? a : !0;
  }
  function aa(a) {
    var b = Array(a);
    for (var c = 0; c < a; c++) b[c] = v();
    return b;
  }
  function v() {
    return Object.create(null);
  }
  function ba(a, b) {
    return b.length - a.length;
  }
  function x(a) {
    return "string" === typeof a;
  }
  function C(a) {
    return "object" === _typeof(a);
  }
  function D(a) {
    return "function" === typeof a;
  }
  ;
  function ca(a, b) {
    var c = da;
    if (a && (b && (a = E(a, b)), this.H && (a = E(a, this.H)), this.J && 1 < a.length && (a = E(a, this.J)), c || "" === c)) {
      a = a.split(c);
      if (this.filter) {
        b = this.filter;
        c = a.length;
        var d = [];
        for (var e = 0, f = 0; e < c; e++) {
          var g = a[e];
          g && !b[g] && (d[f++] = g);
        }
        a = d;
      }
      return a;
    }
    return a;
  }
  var da = /(?:[\0-\/:-@\[-`\{-\xA9\xAB-\xB1\xB4\xB6-\xB8\xBB\xBF\xD7\xF7\u02C2-\u02C5\u02D2-\u02DF\u02E5-\u02EB\u02ED\u02EF-\u02FF\u0375\u0378\u0379\u037E\u0380-\u0385\u0387\u038B\u038D\u03A2\u03F6\u0482\u0530\u0557\u0558\u055A-\u055F\u0589-\u0590\u05BE\u05C0\u05C3\u05C6\u05C8-\u05CF\u05EB-\u05EE\u05F3-\u060F\u061B-\u061F\u066A-\u066D\u06D4\u06DD\u06DE\u06E9\u06FD\u06FE\u0700-\u070F\u074B\u074C\u07B2-\u07BF\u07F6-\u07F9\u07FB\u07FC\u07FE\u07FF\u082E-\u083F\u085C-\u085F\u086B-\u086F\u0888\u088F-\u0897\u08E2\u0964\u0965\u0970\u0984\u098D\u098E\u0991\u0992\u09A9\u09B1\u09B3-\u09B5\u09BA\u09BB\u09C5\u09C6\u09C9\u09CA\u09CF-\u09D6\u09D8-\u09DB\u09DE\u09E4\u09E5\u09F2\u09F3\u09FA\u09FB\u09FD\u09FF\u0A00\u0A04\u0A0B-\u0A0E\u0A11\u0A12\u0A29\u0A31\u0A34\u0A37\u0A3A\u0A3B\u0A3D\u0A43-\u0A46\u0A49\u0A4A\u0A4E-\u0A50\u0A52-\u0A58\u0A5D\u0A5F-\u0A65\u0A76-\u0A80\u0A84\u0A8E\u0A92\u0AA9\u0AB1\u0AB4\u0ABA\u0ABB\u0AC6\u0ACA\u0ACE\u0ACF\u0AD1-\u0ADF\u0AE4\u0AE5\u0AF0-\u0AF8\u0B00\u0B04\u0B0D\u0B0E\u0B11\u0B12\u0B29\u0B31\u0B34\u0B3A\u0B3B\u0B45\u0B46\u0B49\u0B4A\u0B4E-\u0B54\u0B58-\u0B5B\u0B5E\u0B64\u0B65\u0B70\u0B78-\u0B81\u0B84\u0B8B-\u0B8D\u0B91\u0B96-\u0B98\u0B9B\u0B9D\u0BA0-\u0BA2\u0BA5-\u0BA7\u0BAB-\u0BAD\u0BBA-\u0BBD\u0BC3-\u0BC5\u0BC9\u0BCE\u0BCF\u0BD1-\u0BD6\u0BD8-\u0BE5\u0BF3-\u0BFF\u0C0D\u0C11\u0C29\u0C3A\u0C3B\u0C45\u0C49\u0C4E-\u0C54\u0C57\u0C5B\u0C5C\u0C5E\u0C5F\u0C64\u0C65\u0C70-\u0C77\u0C7F\u0C84\u0C8D\u0C91\u0CA9\u0CB4\u0CBA\u0CBB\u0CC5\u0CC9\u0CCE-\u0CD4\u0CD7-\u0CDC\u0CDF\u0CE4\u0CE5\u0CF0\u0CF4-\u0CFF\u0D0D\u0D11\u0D45\u0D49\u0D4F-\u0D53\u0D64\u0D65\u0D79\u0D80\u0D84\u0D97-\u0D99\u0DB2\u0DBC\u0DBE\u0DBF\u0DC7-\u0DC9\u0DCB-\u0DCE\u0DD5\u0DD7\u0DE0-\u0DE5\u0DF0\u0DF1\u0DF4-\u0E00\u0E3B-\u0E3F\u0E4F\u0E5A-\u0E80\u0E83\u0E85\u0E8B\u0EA4\u0EA6\u0EBE\u0EBF\u0EC5\u0EC7\u0ECF\u0EDA\u0EDB\u0EE0-\u0EFF\u0F01-\u0F17\u0F1A-\u0F1F\u0F34\u0F36\u0F38\u0F3A-\u0F3D\u0F48\u0F6D-\u0F70\u0F85\u0F98\u0FBD-\u0FC5\u0FC7-\u0FFF\u104A-\u104F\u109E\u109F\u10C6\u10C8-\u10CC\u10CE\u10CF\u10FB\u1249\u124E\u124F\u1257\u1259\u125E\u125F\u1289\u128E\u128F\u12B1\u12B6\u12B7\u12BF\u12C1\u12C6\u12C7\u12D7\u1311\u1316\u1317\u135B\u135C\u1360-\u1368\u137D-\u137F\u1390-\u139F\u13F6\u13F7\u13FE-\u1400\u166D\u166E\u1680\u169B-\u169F\u16EB-\u16ED\u16F9-\u16FF\u1716-\u171E\u1735-\u173F\u1754-\u175F\u176D\u1771\u1774-\u177F\u17D4-\u17D6\u17D8-\u17DB\u17DE\u17DF\u17EA-\u17EF\u17FA-\u180A\u180E\u181A-\u181F\u1879-\u187F\u18AB-\u18AF\u18F6-\u18FF\u191F\u192C-\u192F\u193C-\u1945\u196E\u196F\u1975-\u197F\u19AC-\u19AF\u19CA-\u19CF\u19DB-\u19FF\u1A1C-\u1A1F\u1A5F\u1A7D\u1A7E\u1A8A-\u1A8F\u1A9A-\u1AA6\u1AA8-\u1AAF\u1ACF-\u1AFF\u1B4D-\u1B4F\u1B5A-\u1B6A\u1B74-\u1B7F\u1BF4-\u1BFF\u1C38-\u1C3F\u1C4A-\u1C4C\u1C7E\u1C7F\u1C89-\u1C8F\u1CBB\u1CBC\u1CC0-\u1CCF\u1CD3\u1CFB-\u1CFF\u1F16\u1F17\u1F1E\u1F1F\u1F46\u1F47\u1F4E\u1F4F\u1F58\u1F5A\u1F5C\u1F5E\u1F7E\u1F7F\u1FB5\u1FBD\u1FBF-\u1FC1\u1FC5\u1FCD-\u1FCF\u1FD4\u1FD5\u1FDC-\u1FDF\u1FED-\u1FF1\u1FF5\u1FFD-\u206F\u2072\u2073\u207A-\u207E\u208A-\u208F\u209D-\u20CF\u20F1-\u2101\u2103-\u2106\u2108\u2109\u2114\u2116-\u2118\u211E-\u2123\u2125\u2127\u2129\u212E\u213A\u213B\u2140-\u2144\u214A-\u214D\u214F\u218A-\u245F\u249C-\u24E9\u2500-\u2775\u2794-\u2BFF\u2CE5-\u2CEA\u2CF4-\u2CFC\u2CFE\u2CFF\u2D26\u2D28-\u2D2C\u2D2E\u2D2F\u2D68-\u2D6E\u2D70-\u2D7E\u2D97-\u2D9F\u2DA7\u2DAF\u2DB7\u2DBF\u2DC7\u2DCF\u2DD7\u2DDF\u2E00-\u2E2E\u2E30-\u3004\u3008-\u3020\u3030\u3036\u3037\u303D-\u3040\u3097\u3098\u309B\u309C\u30A0\u30FB\u3100-\u3104\u3130\u318F-\u3191\u3196-\u319F\u31C0-\u31EF\u3200-\u321F\u322A-\u3247\u3250\u3260-\u327F\u328A-\u32B0\u32C0-\u33FF\u4DC0-\u4DFF\uA48D-\uA4CF\uA4FE\uA4FF\uA60D-\uA60F\uA62C-\uA63F\uA673\uA67E\uA6F2-\uA716\uA720\uA721\uA789\uA78A\uA7CB-\uA7CF\uA7D2\uA7D4\uA7DA-\uA7F1\uA828-\uA82B\uA82D-\uA82F\uA836-\uA83F\uA874-\uA87F\uA8C6-\uA8CF\uA8DA-\uA8DF\uA8F8-\uA8FA\uA8FC\uA92E\uA92F\uA954-\uA95F\uA97D-\uA97F\uA9C1-\uA9CE\uA9DA-\uA9DF\uA9FF\uAA37-\uAA3F\uAA4E\uAA4F\uAA5A-\uAA5F\uAA77-\uAA79\uAAC3-\uAADA\uAADE\uAADF\uAAF0\uAAF1\uAAF7-\uAB00\uAB07\uAB08\uAB0F\uAB10\uAB17-\uAB1F\uAB27\uAB2F\uAB5B\uAB6A-\uAB6F\uABEB\uABEE\uABEF\uABFA-\uABFF\uD7A4-\uD7AF\uD7C7-\uD7CA\uD7FC-\uD7FF\uE000-\uF8FF\uFA6E\uFA6F\uFADA-\uFAFF\uFB07-\uFB12\uFB18-\uFB1C\uFB29\uFB37\uFB3D\uFB3F\uFB42\uFB45\uFBB2-\uFBD2\uFD3E-\uFD4F\uFD90\uFD91\uFDC8-\uFDEF\uFDFC-\uFDFF\uFE10-\uFE1F\uFE30-\uFE6F\uFE75\uFEFD-\uFF0F\uFF1A-\uFF20\uFF3B-\uFF40\uFF5B-\uFF65\uFFBF-\uFFC1\uFFC8\uFFC9\uFFD0\uFFD1\uFFD8\uFFD9\uFFDD-\uFFFF]|\uD800[\uDC0C\uDC27\uDC3B\uDC3E\uDC4E\uDC4F\uDC5E-\uDC7F\uDCFB-\uDD06\uDD34-\uDD3F\uDD79-\uDD89\uDD8C-\uDDFC\uDDFE-\uDE7F\uDE9D-\uDE9F\uDED1-\uDEDF\uDEFC-\uDEFF\uDF24-\uDF2C\uDF4B-\uDF4F\uDF7B-\uDF7F\uDF9E\uDF9F\uDFC4-\uDFC7\uDFD0\uDFD6-\uDFFF]|\uD801[\uDC9E\uDC9F\uDCAA-\uDCAF\uDCD4-\uDCD7\uDCFC-\uDCFF\uDD28-\uDD2F\uDD64-\uDD6F\uDD7B\uDD8B\uDD93\uDD96\uDDA2\uDDB2\uDDBA\uDDBD-\uDDFF\uDF37-\uDF3F\uDF56-\uDF5F\uDF68-\uDF7F\uDF86\uDFB1\uDFBB-\uDFFF]|\uD802[\uDC06\uDC07\uDC09\uDC36\uDC39-\uDC3B\uDC3D\uDC3E\uDC56\uDC57\uDC77\uDC78\uDC9F-\uDCA6\uDCB0-\uDCDF\uDCF3\uDCF6-\uDCFA\uDD1C-\uDD1F\uDD3A-\uDD7F\uDDB8-\uDDBB\uDDD0\uDDD1\uDE04\uDE07-\uDE0B\uDE14\uDE18\uDE36\uDE37\uDE3B-\uDE3E\uDE49-\uDE5F\uDE7F\uDEA0-\uDEBF\uDEC8\uDEE7-\uDEEA\uDEF0-\uDEFF\uDF36-\uDF3F\uDF56\uDF57\uDF73-\uDF77\uDF92-\uDFA8\uDFB0-\uDFFF]|\uD803[\uDC49-\uDC7F\uDCB3-\uDCBF\uDCF3-\uDCF9\uDD28-\uDD2F\uDD3A-\uDE5F\uDE7F\uDEAA\uDEAD-\uDEAF\uDEB2-\uDEFC\uDF28-\uDF2F\uDF55-\uDF6F\uDF86-\uDFAF\uDFCC-\uDFDF\uDFF7-\uDFFF]|\uD804[\uDC47-\uDC51\uDC76-\uDC7E\uDCBB-\uDCC1\uDCC3-\uDCCF\uDCE9-\uDCEF\uDCFA-\uDCFF\uDD35\uDD40-\uDD43\uDD48-\uDD4F\uDD74\uDD75\uDD77-\uDD7F\uDDC5-\uDDC8\uDDCD\uDDDB\uDDDD-\uDDE0\uDDF5-\uDDFF\uDE12\uDE38-\uDE3D\uDE42-\uDE7F\uDE87\uDE89\uDE8E\uDE9E\uDEA9-\uDEAF\uDEEB-\uDEEF\uDEFA-\uDEFF\uDF04\uDF0D\uDF0E\uDF11\uDF12\uDF29\uDF31\uDF34\uDF3A\uDF45\uDF46\uDF49\uDF4A\uDF4E\uDF4F\uDF51-\uDF56\uDF58-\uDF5C\uDF64\uDF65\uDF6D-\uDF6F\uDF75-\uDFFF]|\uD805[\uDC4B-\uDC4F\uDC5A-\uDC5D\uDC62-\uDC7F\uDCC6\uDCC8-\uDCCF\uDCDA-\uDD7F\uDDB6\uDDB7\uDDC1-\uDDD7\uDDDE-\uDDFF\uDE41-\uDE43\uDE45-\uDE4F\uDE5A-\uDE7F\uDEB9-\uDEBF\uDECA-\uDEFF\uDF1B\uDF1C\uDF2C-\uDF2F\uDF3C-\uDF3F\uDF47-\uDFFF]|\uD806[\uDC3B-\uDC9F\uDCF3-\uDCFE\uDD07\uDD08\uDD0A\uDD0B\uDD14\uDD17\uDD36\uDD39\uDD3A\uDD44-\uDD4F\uDD5A-\uDD9F\uDDA8\uDDA9\uDDD8\uDDD9\uDDE2\uDDE5-\uDDFF\uDE3F-\uDE46\uDE48-\uDE4F\uDE9A-\uDE9C\uDE9E-\uDEAF\uDEF9-\uDFFF]|\uD807[\uDC09\uDC37\uDC41-\uDC4F\uDC6D-\uDC71\uDC90\uDC91\uDCA8\uDCB7-\uDCFF\uDD07\uDD0A\uDD37-\uDD39\uDD3B\uDD3E\uDD48-\uDD4F\uDD5A-\uDD5F\uDD66\uDD69\uDD8F\uDD92\uDD99-\uDD9F\uDDAA-\uDEDF\uDEF7-\uDEFF\uDF11\uDF3B-\uDF3D\uDF43-\uDF4F\uDF5A-\uDFAF\uDFB1-\uDFBF\uDFD5-\uDFFF]|\uD808[\uDF9A-\uDFFF]|\uD809[\uDC6F-\uDC7F\uDD44-\uDFFF]|[\uD80A\uD80E-\uD810\uD812-\uD819\uD824-\uD82A\uD82D\uD82E\uD830-\uD832\uD83D\uD83F\uD87B-\uD87D\uD87F\uD889-\uDB3F\uDB41-\uDBFF][\uDC00-\uDFFF]|\uD80B[\uDC00-\uDF8F\uDFF1-\uDFFF]|\uD80D[\uDC30-\uDC3F\uDC56-\uDFFF]|\uD811[\uDE47-\uDFFF]|\uD81A[\uDE39-\uDE3F\uDE5F\uDE6A-\uDE6F\uDEBF\uDECA-\uDECF\uDEEE\uDEEF\uDEF5-\uDEFF\uDF37-\uDF3F\uDF44-\uDF4F\uDF5A\uDF62\uDF78-\uDF7C\uDF90-\uDFFF]|\uD81B[\uDC00-\uDE3F\uDE97-\uDEFF\uDF4B-\uDF4E\uDF88-\uDF8E\uDFA0-\uDFDF\uDFE2\uDFE5-\uDFEF\uDFF2-\uDFFF]|\uD821[\uDFF8-\uDFFF]|\uD823[\uDCD6-\uDCFF\uDD09-\uDFFF]|\uD82B[\uDC00-\uDFEF\uDFF4\uDFFC\uDFFF]|\uD82C[\uDD23-\uDD31\uDD33-\uDD4F\uDD53\uDD54\uDD56-\uDD63\uDD68-\uDD6F\uDEFC-\uDFFF]|\uD82F[\uDC6B-\uDC6F\uDC7D-\uDC7F\uDC89-\uDC8F\uDC9A-\uDC9C\uDC9F-\uDFFF]|\uD833[\uDC00-\uDEFF\uDF2E\uDF2F\uDF47-\uDFFF]|\uD834[\uDC00-\uDD64\uDD6A-\uDD6C\uDD73-\uDD7A\uDD83\uDD84\uDD8C-\uDDA9\uDDAE-\uDE41\uDE45-\uDEBF\uDED4-\uDEDF\uDEF4-\uDF5F\uDF79-\uDFFF]|\uD835[\uDC55\uDC9D\uDCA0\uDCA1\uDCA3\uDCA4\uDCA7\uDCA8\uDCAD\uDCBA\uDCBC\uDCC4\uDD06\uDD0B\uDD0C\uDD15\uDD1D\uDD3A\uDD3F\uDD45\uDD47-\uDD49\uDD51\uDEA6\uDEA7\uDEC1\uDEDB\uDEFB\uDF15\uDF35\uDF4F\uDF6F\uDF89\uDFA9\uDFC3\uDFCC\uDFCD]|\uD836[\uDC00-\uDDFF\uDE37-\uDE3A\uDE6D-\uDE74\uDE76-\uDE83\uDE85-\uDE9A\uDEA0\uDEB0-\uDFFF]|\uD837[\uDC00-\uDEFF\uDF1F-\uDF24\uDF2B-\uDFFF]|\uD838[\uDC07\uDC19\uDC1A\uDC22\uDC25\uDC2B-\uDC2F\uDC6E-\uDC8E\uDC90-\uDCFF\uDD2D-\uDD2F\uDD3E\uDD3F\uDD4A-\uDD4D\uDD4F-\uDE8F\uDEAF-\uDEBF\uDEFA-\uDFFF]|\uD839[\uDC00-\uDCCF\uDCFA-\uDFDF\uDFE7\uDFEC\uDFEF\uDFFF]|\uD83A[\uDCC5\uDCC6\uDCD7-\uDCFF\uDD4C-\uDD4F\uDD5A-\uDFFF]|\uD83B[\uDC00-\uDC70\uDCAC\uDCB0\uDCB5-\uDD00\uDD2E\uDD3E-\uDDFF\uDE04\uDE20\uDE23\uDE25\uDE26\uDE28\uDE33\uDE38\uDE3A\uDE3C-\uDE41\uDE43-\uDE46\uDE48\uDE4A\uDE4C\uDE50\uDE53\uDE55\uDE56\uDE58\uDE5A\uDE5C\uDE5E\uDE60\uDE63\uDE65\uDE66\uDE6B\uDE73\uDE78\uDE7D\uDE7F\uDE8A\uDE9C-\uDEA0\uDEA4\uDEAA\uDEBC-\uDFFF]|\uD83C[\uDC00-\uDCFF\uDD0D-\uDFFF]|\uD83E[\uDC00-\uDFEF\uDFFA-\uDFFF]|\uD869[\uDEE0-\uDEFF]|\uD86D[\uDF3A-\uDF3F]|\uD86E[\uDC1E\uDC1F]|\uD873[\uDEA2-\uDEAF]|\uD87A[\uDFE1-\uDFFF]|\uD87E[\uDE1E-\uDFFF]|\uD884[\uDF4B-\uDF4F]|\uD888[\uDFB0-\uDFFF]|\uDB40[\uDC00-\uDCFF\uDDF0-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+/,
    ea = /[\u0300-\u036f]/g;
  function fa(a, b) {
    var c = Object.keys(a),
      d = c.length,
      e = [];
    var f = "",
      g = 0;
    for (var h = 0, k, m; h < d; h++) k = c[h], (m = a[k]) ? (e[g++] = F(b ? "(?!\\b)" + k + "(\\b|_)" : k), e[g++] = m) : f += (f ? "|" : "") + k;
    f && (e[g++] = F(b ? "(?!\\b)(" + f + ")(\\b|_)" : "(" + f + ")"), e[g] = "");
    return e;
  }
  function E(a, b) {
    for (var c = 0, d = b.length; c < d && (a = a.replace(b[c], b[c + 1]), a); c += 2);
    return a;
  }
  function F(a) {
    return new RegExp(a, "g");
  }
  function ha(a) {
    var b = "",
      c = "";
    for (var d = 0, e = a.length, f; d < e; d++) (f = a[d]) !== c && (b += c = f);
    return b;
  }
  ;
  var ja = {
    encode: ia,
    F: !1,
    G: ""
  };
  function ia(a) {
    return ca.call(this, ("" + a).toLowerCase(), !1);
  }
  ;
  var ka = {},
    G = {};
  function la(a) {
    I(a, "add");
    I(a, "append");
    I(a, "search");
    I(a, "update");
    I(a, "remove");
  }
  function I(a, b) {
    a[b + "Async"] = function () {
      var c = this,
        d = arguments;
      var e = d[d.length - 1];
      var f;
      D(e) && (f = e, delete d[d.length - 1]);
      e = new Promise(function (g) {
        setTimeout(function () {
          c.async = !0;
          var h = c[b].apply(c, d);
          c.async = !1;
          g(h);
        });
      });
      return f ? (e.then(f), this) : e;
    };
  }
  ;
  function ma(a, b, c, d) {
    var e = a.length;
    var f = [],
      g,
      h,
      k = 0;
    d && (d = []);
    for (var m = e - 1; 0 <= m; m--) {
      var n = a[m],
        w = n.length,
        q = v();
      var r = !g;
      for (var l = 0; l < w; l++) {
        var p = n[l],
          z = p.length;
        if (z) for (var B = 0, A, y; B < z; B++) if (y = p[B], g) {
          if (g[y]) {
            if (!m) if (c) c--;else if (f[k++] = y, k === b) return f;
            if (m || d) q[y] = 1;
            r = !0;
          }
          if (d && (A = (h[y] || 0) + 1, h[y] = A, A < e)) {
            var H = d[A - 2] || (d[A - 2] = []);
            H[H.length] = y;
          }
        } else q[y] = 1;
      }
      if (d) g || (h = q);else if (!r) return [];
      g = q;
    }
    if (d) for (var _m = d.length - 1, _n, _w; 0 <= _m; _m--) {
      _n = d[_m];
      _w = _n.length;
      for (var _q = 0, _r; _q < _w; _q++) if (_r = _n[_q], !g[_r]) {
        if (c) c--;else if (f[k++] = _r, k === b) return f;
        g[_r] = 1;
      }
    }
    return f;
  }
  function na(a, b) {
    var c = v(),
      d = v(),
      e = [];
    for (var f = 0; f < a.length; f++) c[a[f]] = 1;
    for (var _f2 = 0, g; _f2 < b.length; _f2++) {
      g = b[_f2];
      for (var h = 0, k; h < g.length; h++) k = g[h], c[k] && !d[k] && (d[k] = 1, e[e.length] = k);
    }
    return e;
  }
  ;
  function J(a) {
    this.l = !0 !== a && a;
    this.cache = v();
    this.h = [];
  }
  function oa(a, b, c) {
    C(a) && (a = a.query);
    var d = this.cache.get(a);
    d || (d = this.search(a, b, c), this.cache.set(a, d));
    return d;
  }
  J.prototype.set = function (a, b) {
    if (!this.cache[a]) {
      var c = this.h.length;
      c === this.l ? delete this.cache[this.h[c - 1]] : c++;
      for (--c; 0 < c; c--) this.h[c] = this.h[c - 1];
      this.h[0] = a;
    }
    this.cache[a] = b;
  };
  J.prototype.get = function (a) {
    var b = this.cache[a];
    if (this.l && b && (a = this.h.indexOf(a))) {
      var c = this.h[a - 1];
      this.h[a - 1] = this.h[a];
      this.h[a] = c;
    }
    return b;
  };
  var qa = {
    memory: {
      charset: "latin:extra",
      D: 3,
      B: 4,
      m: !1
    },
    performance: {
      D: 3,
      B: 3,
      s: !1,
      context: {
        depth: 2,
        D: 1
      }
    },
    match: {
      charset: "latin:extra",
      G: "reverse"
    },
    score: {
      charset: "latin:advanced",
      D: 20,
      B: 3,
      context: {
        depth: 3,
        D: 9
      }
    },
    "default": {}
  };
  function ra(a, b, c, d, e, f, g) {
    setTimeout(function () {
      var h = a(c ? c + "." + d : d, JSON.stringify(g));
      h && h.then ? h.then(function () {
        b.export(a, b, c, e, f + 1);
      }) : b.export(a, b, c, e, f + 1);
    });
  }
  ;
  function K(a, b) {
    if (!(this instanceof K)) return new K(a);
    var c;
    if (a) {
      x(a) ? a = qa[a] : (c = a.preset) && (a = Object.assign({}, c[c], a));
      c = a.charset;
      var d = a.lang;
      x(c) && (-1 === c.indexOf(":") && (c += ":default"), c = G[c]);
      x(d) && (d = ka[d]);
    } else a = {};
    var e,
      f,
      g = a.context || {};
    this.encode = a.encode || c && c.encode || ia;
    this.register = b || v();
    this.D = e = a.resolution || 9;
    this.G = b = c && c.G || a.tokenize || "strict";
    this.depth = "strict" === b && g.depth;
    this.l = u(g.bidirectional);
    this.s = f = u(a.optimize);
    this.m = u(a.fastupdate);
    this.B = a.minlength || 1;
    this.C = a.boost;
    this.map = f ? aa(e) : v();
    this.A = e = g.resolution || 1;
    this.h = f ? aa(e) : v();
    this.F = c && c.F || a.rtl;
    this.H = (b = a.matcher || d && d.H) && fa(b, !1);
    this.J = (b = a.stemmer || d && d.J) && fa(b, !0);
    if (c = b = a.filter || d && d.filter) {
      c = b;
      d = v();
      for (var h = 0, k = c.length; h < k; h++) d[c[h]] = 1;
      c = d;
    }
    this.filter = c;
    this.cache = (b = a.cache) && new J(b);
  }
  t = K.prototype;
  t.append = function (a, b) {
    return this.add(a, b, !0);
  };
  t.add = function (a, b, c, d) {
    if (b && (a || 0 === a)) {
      if (!d && !c && this.register[a]) return this.update(a, b);
      b = this.encode(b);
      if (d = b.length) {
        var m = v(),
          n = v(),
          w = this.depth,
          q = this.D;
        for (var r = 0; r < d; r++) {
          var l = b[this.F ? d - 1 - r : r];
          var e = l.length;
          if (l && e >= this.B && (w || !n[l])) {
            var f = L(q, d, r),
              g = "";
            switch (this.G) {
              case "full":
                if (2 < e) {
                  for (f = 0; f < e; f++) for (var h = e; h > f; h--) if (h - f >= this.B) {
                    var k = L(q, d, r, e, f);
                    g = l.substring(f, h);
                    M(this, n, g, k, a, c);
                  }
                  break;
                }
              case "reverse":
                if (1 < e) {
                  for (h = e - 1; 0 < h; h--) g = l[h] + g, g.length >= this.B && M(this, n, g, L(q, d, r, e, h), a, c);
                  g = "";
                }
              case "forward":
                if (1 < e) {
                  for (h = 0; h < e; h++) g += l[h], g.length >= this.B && M(this, n, g, f, a, c);
                  break;
                }
              default:
                if (this.C && (f = Math.min(f / this.C(b, l, r) | 0, q - 1)), M(this, n, l, f, a, c), w && 1 < d && r < d - 1) for (e = v(), g = this.A, f = l, h = Math.min(w + 1, d - r), e[f] = 1, k = 1; k < h; k++) if ((l = b[this.F ? d - 1 - r - k : r + k]) && l.length >= this.B && !e[l]) {
                  e[l] = 1;
                  var p = this.l && l > f;
                  M(this, m, p ? f : l, L(g + (d / 2 > g ? 0 : 1), d, r, h - 1, k - 1), a, c, p ? l : f);
                }
            }
          }
        }
        this.m || (this.register[a] = 1);
      }
    }
    return this;
  };
  function L(a, b, c, d, e) {
    return c && 1 < a ? b + (d || 0) <= a ? c + (e || 0) : (a - 1) / (b + (d || 0)) * (c + (e || 0)) + 1 | 0 : 0;
  }
  function M(a, b, c, d, e, f, g) {
    var h = g ? a.h : a.map;
    if (!b[c] || g && !b[c][g]) a.s && (h = h[d]), g ? (b = b[c] || (b[c] = v()), b[g] = 1, h = h[g] || (h[g] = v())) : b[c] = 1, h = h[c] || (h[c] = []), a.s || (h = h[d] || (h[d] = [])), f && h.includes(e) || (h[h.length] = e, a.m && (a = a.register[e] || (a.register[e] = []), a[a.length] = h));
  }
  t.search = function (a, b, c) {
    c || (!b && C(a) ? (c = a, a = c.query) : C(b) && (c = b));
    var d = [],
      e;
    var f,
      g = 0;
    if (c) {
      a = c.query || a;
      b = c.limit;
      g = c.offset || 0;
      var h = c.context;
      f = c.suggest;
    }
    if (a && (a = this.encode("" + a), e = a.length, 1 < e)) {
      c = v();
      var k = [];
      for (var n = 0, w = 0, q; n < e; n++) if ((q = a[n]) && q.length >= this.B && !c[q]) if (this.s || f || this.map[q]) k[w++] = q, c[q] = 1;else return d;
      a = k;
      e = a.length;
    }
    if (!e) return d;
    b || (b = 100);
    h = this.depth && 1 < e && !1 !== h;
    c = 0;
    var m;
    h ? (m = a[0], c = 1) : 1 < e && a.sort(ba);
    for (var _n2, _w2; c < e; c++) {
      _w2 = a[c];
      h ? (_n2 = sa(this, d, f, b, g, 2 === e, _w2, m), f && !1 === _n2 && d.length || (m = _w2)) : _n2 = sa(this, d, f, b, g, 1 === e, _w2);
      if (_n2) return _n2;
      if (f && c === e - 1) {
        k = d.length;
        if (!k) {
          if (h) {
            h = 0;
            c = -1;
            continue;
          }
          return d;
        }
        if (1 === k) return ta(d[0], b, g);
      }
    }
    return ma(d, b, g, f);
  };
  function sa(a, b, c, d, e, f, g, h) {
    var k = [],
      m = h ? a.h : a.map;
    a.s || (m = ua(m, g, h, a.l));
    if (m) {
      var n = 0;
      var w = Math.min(m.length, h ? a.A : a.D);
      for (var q = 0, r = 0, l, p; q < w; q++) if (l = m[q]) if (a.s && (l = ua(l, g, h, a.l)), e && l && f && (p = l.length, p <= e ? (e -= p, l = null) : (l = l.slice(e), e = 0)), l && (k[n++] = l, f && (r += l.length, r >= d))) break;
      if (n) {
        if (f) return ta(k, d, 0);
        b[b.length] = k;
        return;
      }
    }
    return !c && k;
  }
  function ta(a, b, c) {
    a = 1 === a.length ? a[0] : [].concat.apply([], a);
    return c || a.length > b ? a.slice(c, c + b) : a;
  }
  function ua(a, b, c, d) {
    c ? (d = d && b > c, a = (a = a[d ? b : c]) && a[d ? c : b]) : a = a[b];
    return a;
  }
  t.contain = function (a) {
    return !!this.register[a];
  };
  t.update = function (a, b) {
    return this.remove(a).add(a, b);
  };
  t.remove = function (a, b) {
    var c = this.register[a];
    if (c) {
      if (this.m) for (var d = 0, e; d < c.length; d++) e = c[d], e.splice(e.indexOf(a), 1);else N(this.map, a, this.D, this.s), this.depth && N(this.h, a, this.A, this.s);
      b || delete this.register[a];
      if (this.cache) {
        b = this.cache;
        for (var _d = 0, _e, f; _d < b.h.length; _d++) f = b.h[_d], _e = b.cache[f], _e.includes(a) && (b.h.splice(_d--, 1), delete b.cache[f]);
      }
    }
    return this;
  };
  function N(a, b, c, d, e) {
    var f = 0;
    if (a.constructor === Array) {
      if (e) b = a.indexOf(b), -1 !== b ? 1 < a.length && (a.splice(b, 1), f++) : f++;else {
        e = Math.min(a.length, c);
        for (var g = 0, h; g < e; g++) if (h = a[g]) f = N(h, b, c, d, e), d || f || delete a[g];
      }
    } else for (var _g in a) (f = N(a[_g], b, c, d, e)) || delete a[_g];
    return f;
  }
  t.searchCache = oa;
  t.export = function (a, b, c, d, e) {
    var f, g;
    switch (e || (e = 0)) {
      case 0:
        f = "reg";
        if (this.m) {
          g = v();
          for (var h in this.register) g[h] = 1;
        } else g = this.register;
        break;
      case 1:
        f = "cfg";
        g = {
          doc: 0,
          opt: this.s ? 1 : 0
        };
        break;
      case 2:
        f = "map";
        g = this.map;
        break;
      case 3:
        f = "ctx";
        g = this.h;
        break;
      default:
        return;
    }
    ra(a, b || this, c, f, d, e, g);
    return !0;
  };
  t.import = function (a, b) {
    if (b) switch (x(b) && (b = JSON.parse(b)), a) {
      case "cfg":
        this.s = !!b.opt;
        break;
      case "reg":
        this.m = !1;
        this.register = b;
        break;
      case "map":
        this.map = b;
        break;
      case "ctx":
        this.h = b;
    }
  };
  la(K.prototype);
  function va(a) {
    a = a.data;
    var b = self._index;
    var c = a.args;
    var d = a.task;
    switch (d) {
      case "init":
        d = a.options || {};
        a = a.factory;
        b = d.encode;
        d.cache = !1;
        b && 0 === b.indexOf("function") && (d.encode = Function("return " + b)());
        a ? (Function("return " + a)()(self), self._index = new self.FlexSearch.Index(d), delete self.FlexSearch) : self._index = new K(d);
        break;
      default:
        a = a.id, b = b[d].apply(b, c), postMessage("search" === d ? {
          id: a,
          msg: b
        } : {
          id: a
        });
    }
  }
  ;
  var wa = 0;
  function O(a) {
    if (!(this instanceof O)) return new O(a);
    var b;
    a ? D(b = a.encode) && (a.encode = b.toString()) : a = {};
    (b = (self || window)._factory) && (b = b.toString());
    var c = "undefined" === typeof window && self.exports,
      d = this;
    this.o = xa(b, c, a.worker);
    this.h = v();
    if (this.o) {
      if (c) this.o.on("message", function (e) {
        d.h[e.id](e.msg);
        delete d.h[e.id];
      });else this.o.onmessage = function (e) {
        e = e.data;
        d.h[e.id](e.msg);
        delete d.h[e.id];
      };
      this.o.postMessage({
        task: "init",
        factory: b,
        options: a
      });
    }
  }
  P("add");
  P("append");
  P("search");
  P("update");
  P("remove");
  function P(a) {
    O.prototype[a] = O.prototype[a + "Async"] = function () {
      var b = this,
        c = [].slice.call(arguments);
      var d = c[c.length - 1];
      var e;
      D(d) && (e = d, c.splice(c.length - 1, 1));
      d = new Promise(function (f) {
        setTimeout(function () {
          b.h[++wa] = f;
          b.o.postMessage({
            task: a,
            id: wa,
            args: c
          });
        });
      });
      return e ? (d.then(e), this) : d;
    };
  }
  function xa(a, b, c) {
    var d;
    try {
      d = b ? eval('new (require("worker_threads")["Worker"])("../dist/node/node.js")') : a ? new Worker(URL.createObjectURL(new Blob(["onmessage=" + va.toString()], {
        type: "text/javascript"
      }))) : new Worker(x(c) ? c : "worker/worker.js", {
        type: "module"
      });
    } catch (e) {}
    return d;
  }
  ;
  function Q(a) {
    if (!(this instanceof Q)) return new Q(a);
    var b = a.document || a.doc || a,
      c;
    this.K = [];
    this.h = [];
    this.A = [];
    this.register = v();
    this.key = (c = b.key || b.id) && S(c, this.A) || "id";
    this.m = u(a.fastupdate);
    this.C = (c = b.store) && !0 !== c && [];
    this.store = c && v();
    this.I = (c = b.tag) && S(c, this.A);
    this.l = c && v();
    this.cache = (c = a.cache) && new J(c);
    a.cache = !1;
    this.o = a.worker;
    this.async = !1;
    c = v();
    var d = b.index || b.field || b;
    x(d) && (d = [d]);
    for (var e = 0, f, g; e < d.length; e++) f = d[e], x(f) || (g = f, f = f.field), g = C(g) ? Object.assign({}, a, g) : a, this.o && (c[f] = new O(g), c[f].o || (this.o = !1)), this.o || (c[f] = new K(g, this.register)), this.K[e] = S(f, this.A), this.h[e] = f;
    if (this.C) for (a = b.store, x(a) && (a = [a]), b = 0; b < a.length; b++) this.C[b] = S(a[b], this.A);
    this.index = c;
  }
  function S(a, b) {
    var c = a.split(":");
    var d = 0;
    for (var e = 0; e < c.length; e++) a = c[e], 0 <= a.indexOf("[]") && (a = a.substring(0, a.length - 2)) && (b[d] = !0), a && (c[d++] = a);
    d < c.length && (c.length = d);
    return 1 < d ? c : c[0];
  }
  function T(a, b) {
    if (x(b)) a = a[b];else for (var c = 0; a && c < b.length; c++) a = a[b[c]];
    return a;
  }
  function U(a, b, c, d, e) {
    a = a[e];
    if (d === c.length - 1) b[e] = a;else if (a) if (a.constructor === Array) for (b = b[e] = Array(a.length), e = 0; e < a.length; e++) U(a, b, c, d, e);else b = b[e] || (b[e] = v()), e = c[++d], U(a, b, c, d, e);
  }
  function V(a, b, c, d, e, f, g, h) {
    if (a = a[g]) if (d === b.length - 1) {
      if (a.constructor === Array) {
        if (c[d]) {
          for (b = 0; b < a.length; b++) e.add(f, a[b], !0, !0);
          return;
        }
        a = a.join(" ");
      }
      e.add(f, a, h, !0);
    } else if (a.constructor === Array) for (g = 0; g < a.length; g++) V(a, b, c, d, e, f, g, h);else g = b[++d], V(a, b, c, d, e, f, g, h);
  }
  t = Q.prototype;
  t.add = function (a, b, c) {
    C(a) && (b = a, a = T(b, this.key));
    if (b && (a || 0 === a)) {
      if (!c && this.register[a]) return this.update(a, b);
      for (var d = 0, e, f; d < this.h.length; d++) f = this.h[d], e = this.K[d], x(e) && (e = [e]), V(b, e, this.A, 0, this.index[f], a, e[0], c);
      if (this.I) {
        var _d2 = T(b, this.I),
          _e2 = v();
        x(_d2) && (_d2 = [_d2]);
        for (var _f3 = 0, g, h; _f3 < _d2.length; _f3++) if (g = _d2[_f3], !_e2[g] && (_e2[g] = 1, h = this.l[g] || (this.l[g] = []), !c || !h.includes(a))) if (h[h.length] = a, this.m) {
          var k = this.register[a] || (this.register[a] = []);
          k[k.length] = h;
        }
      }
      if (this.store && (!c || !this.store[a])) {
        var _d3;
        if (this.C) {
          _d3 = v();
          for (var _e3 = 0, _f4; _e3 < this.C.length; _e3++) _f4 = this.C[_e3], x(_f4) ? _d3[_f4] = b[_f4] : U(b, _d3, _f4, 0, _f4[0]);
        }
        this.store[a] = _d3 || b;
      }
    }
    return this;
  };
  t.append = function (a, b) {
    return this.add(a, b, !0);
  };
  t.update = function (a, b) {
    return this.remove(a).add(a, b);
  };
  t.remove = function (a) {
    C(a) && (a = T(a, this.key));
    if (this.register[a]) {
      for (var b = 0; b < this.h.length && (this.index[this.h[b]].remove(a, !this.o), !this.m); b++);
      if (this.I && !this.m) for (var c in this.l) {
        b = this.l[c];
        var d = b.indexOf(a);
        -1 !== d && (1 < b.length ? b.splice(d, 1) : delete this.l[c]);
      }
      this.store && delete this.store[a];
      delete this.register[a];
    }
    return this;
  };
  t.search = function (a, b, c, d) {
    c || (!b && C(a) ? (c = a, a = "") : C(b) && (c = b, b = 0));
    var e = [],
      f = [],
      g,
      h,
      k,
      m,
      n,
      w,
      q = 0;
    if (c) if (c.constructor === Array) k = c, c = null;else {
      a = c.query || a;
      k = (g = c.pluck) || c.index || c.field;
      m = c.tag;
      h = this.store && c.enrich;
      n = "and" === c.bool;
      b = c.limit || b || 100;
      w = c.offset || 0;
      if (m && (x(m) && (m = [m]), !a)) {
        for (var l = 0, p; l < m.length; l++) if (p = ya.call(this, m[l], b, w, h)) e[e.length] = p, q++;
        return q ? e : [];
      }
      x(k) && (k = [k]);
    }
    k || (k = this.h);
    n = n && (1 < k.length || m && 1 < m.length);
    var r = !d && (this.o || this.async) && [];
    for (var _l = 0, _p, z, B; _l < k.length; _l++) {
      var A = void 0;
      z = k[_l];
      x(z) || (A = z, z = A.field, a = A.query || a, b = A.limit || b);
      if (r) r[_l] = this.index[z].searchAsync(a, b, A || c);else {
        d ? _p = d[_l] : _p = this.index[z].search(a, b, A || c);
        B = _p && _p.length;
        if (m && B) {
          var y = [];
          var H = 0;
          n && (y[0] = [_p]);
          for (var X = 0, pa, R; X < m.length; X++) if (pa = m[X], B = (R = this.l[pa]) && R.length) H++, y[y.length] = n ? [R] : R;
          H && (_p = n ? ma(y, b || 100, w || 0) : na(_p, y), B = _p.length);
        }
        if (B) f[q] = z, e[q++] = _p;else if (n) return [];
      }
    }
    if (r) {
      var _l2 = this;
      return new Promise(function (p) {
        Promise.all(r).then(function (z) {
          p(_l2.search(a, b, c, z));
        });
      });
    }
    if (!q) return [];
    if (g && (!h || !this.store)) return e[0];
    for (var _l3 = 0, _p2; _l3 < f.length; _l3++) {
      _p2 = e[_l3];
      _p2.length && h && (_p2 = za.call(this, _p2));
      if (g) return _p2;
      e[_l3] = {
        field: f[_l3],
        result: _p2
      };
    }
    return e;
  };
  function ya(a, b, c, d) {
    var e = this.l[a],
      f = e && e.length - c;
    if (f && 0 < f) {
      if (f > b || c) e = e.slice(c, c + b);
      d && (e = za.call(this, e));
      return {
        tag: a,
        result: e
      };
    }
  }
  function za(a) {
    var b = Array(a.length);
    for (var c = 0, d; c < a.length; c++) d = a[c], b[c] = {
      id: d,
      doc: this.store[d]
    };
    return b;
  }
  t.contain = function (a) {
    return !!this.register[a];
  };
  t.get = function (a) {
    return this.store[a];
  };
  t.set = function (a, b) {
    this.store[a] = b;
    return this;
  };
  t.searchCache = oa;
  t.export = function (a, b, c, d, e) {
    e || (e = 0);
    d || (d = 0);
    if (d < this.h.length) {
      var f = this.h[d],
        g = this.index[f];
      b = this;
      setTimeout(function () {
        g.export(a, b, e ? f : "", d, e++) || (d++, e = 1, b.export(a, b, f, d, e));
      });
    } else {
      var _f5, _g2;
      switch (e) {
        case 1:
          _f5 = "tag";
          _g2 = this.l;
          break;
        case 2:
          _f5 = "store";
          _g2 = this.store;
          break;
        default:
          return;
      }
      ra(a, this, c, _f5, d, e, _g2);
    }
  };
  t.import = function (a, b) {
    if (b) switch (x(b) && (b = JSON.parse(b)), a) {
      case "tag":
        this.l = b;
        break;
      case "reg":
        this.m = !1;
        this.register = b;
        for (var d = 0, e; d < this.h.length; d++) e = this.index[this.h[d]], e.register = b, e.m = !1;
        break;
      case "store":
        this.store = b;
        break;
      default:
        a = a.split(".");
        var c = a[0];
        a = a[1];
        c && a && this.index[c].import(a, b);
    }
  };
  la(Q.prototype);
  var Ba = {
    encode: Aa,
    F: !1,
    G: ""
  };
  var Ca = [F("[\xE0\xE1\xE2\xE3\xE4\xE5]"), "a", F("[\xE8\xE9\xEA\xEB]"), "e", F("[\xEC\xED\xEE\xEF]"), "i", F("[\xF2\xF3\xF4\xF5\xF6\u0151]"), "o", F("[\xF9\xFA\xFB\xFC\u0171]"), "u", F("[\xFD\u0177\xFF]"), "y", F("\xF1"), "n", F("[\xE7c]"), "k", F("\xDF"), "s", F(" & "), " and "];
  function Aa(a) {
    var b = a = "" + a;
    b.normalize && (b = b.normalize("NFD").replace(ea, ""));
    return ca.call(this, b.toLowerCase(), !a.normalize && Ca);
  }
  ;
  var Ea = {
    encode: Da,
    F: !1,
    G: "strict"
  };
  var Fa = /[^a-z0-9]+/,
    Ga = {
      b: "p",
      v: "f",
      w: "f",
      z: "s",
      x: "s",
      "\xDF": "s",
      d: "t",
      n: "m",
      c: "k",
      g: "k",
      j: "k",
      q: "k",
      i: "e",
      y: "e",
      u: "o"
    };
  function Da(a) {
    a = Aa.call(this, a).join(" ");
    var b = [];
    if (a) {
      var c = a.split(Fa),
        d = c.length;
      for (var e = 0, f, g = 0; e < d; e++) if ((a = c[e]) && (!this.filter || !this.filter[a])) {
        f = a[0];
        var h = Ga[f] || f,
          k = h;
        for (var m = 1; m < a.length; m++) {
          f = a[m];
          var n = Ga[f] || f;
          n && n !== k && (h += n, k = n);
        }
        b[g++] = h;
      }
    }
    return b;
  }
  ;
  var Ia = {
    encode: Ha,
    F: !1,
    G: ""
  };
  var Ja = [F("ae"), "a", F("oe"), "o", F("sh"), "s", F("th"), "t", F("ph"), "f", F("pf"), "f", F("(?![aeo])h(?![aeo])"), "", F("(?!^[aeo])h(?!^[aeo])"), ""];
  function Ha(a, b) {
    a && (a = Da.call(this, a).join(" "), 2 < a.length && (a = E(a, Ja)), b || (1 < a.length && (a = ha(a)), a && (a = a.split(" "))));
    return a || [];
  }
  ;
  var La = {
    encode: Ka,
    F: !1,
    G: ""
  };
  var Ma = F("(?!\\b)[aeo]");
  function Ka(a) {
    a && (a = Ha.call(this, a, !0), 1 < a.length && (a = a.replace(Ma, "")), 1 < a.length && (a = ha(a)), a && (a = a.split(" ")));
    return a || [];
  }
  ;
  G["latin:default"] = ja;
  G["latin:simple"] = Ba;
  G["latin:balance"] = Ea;
  G["latin:advanced"] = Ia;
  G["latin:extra"] = La;
  var W = self;
  var Y;
  var Z = {
    Index: K,
    Document: Q,
    Worker: O,
    registerCharset: function registerCharset(a, b) {
      G[a] = b;
    },
    registerLanguage: function registerLanguage(a, b) {
      ka[a] = b;
    }
  };
  (Y = W.define) && Y.amd ? Y([], function () {
    return Z;
  }) : W.exports ? W.exports = Z : W.FlexSearch = Z;
})(this);